import { transformacion } from 'lib.common';
import { format } from "date-fns";
import { PostTipoCambioResponse } from "../../bussines/entities/PostTipoCambioResponse.entity";
import { paramsPostTipoCambio } from "../../bussines/params/addEditTipoCambio.params";
import { apiRestUrl } from "src/config/keys";


export class AddTipoCambioExpressProvider {
    private apikey: string;
    constructor(apikey: string) {
        this.apikey = apikey;
    }
    async postAddTipoCambio(params: paramsPostTipoCambio): Promise<PostTipoCambioResponse> {
        try {
            const fechaFormateada = format(params.fecha, 'yyyy-MM-dd');
            let url = transformacion.appendUrl(apiRestUrl, `/addTipoCambio`);
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    dsapikey: this.apikey
                },
                body: JSON.stringify({
                    fecha: fechaFormateada,
                    codMoneda: params.moneda,
                    compraFiscal: params.compraFiscal,
                    ventaFiscal: params.ventaFiscal
                })
            });
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    return data;
                }
                throw new Error('No se realizo el proceso');
            }
            const errorText = await response.text();
            throw new Error(`Error ${response.status}: ${response.statusText} - ${errorText}`);
        } catch (error) {
            throw error;
        }
    }
}